/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Groups_Adsense_DescriptionInputs */

const en_admin_settings_groups_adsense_description = /** @type {(inputs: Admin_Settings_Groups_Adsense_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inject the AdSense script sitewide and serve /ads.txt from the configured publisher ID`)
};

const zh_admin_settings_groups_adsense_description = /** @type {(inputs: Admin_Settings_Groups_Adsense_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`全站注入 AdSense 脚本，并根据配置的 Publisher ID 生成 /ads.txt`)
};

/**
* | output |
* | --- |
* | "Inject the AdSense script sitewide and serve /ads.txt from the configured publisher ID" |
*
* @param {Admin_Settings_Groups_Adsense_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_settings_groups_adsense_description = /** @type {((inputs?: Admin_Settings_Groups_Adsense_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Groups_Adsense_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_settings_groups_adsense_description(inputs)
	return zh_admin_settings_groups_adsense_description(inputs)
});
export { admin_settings_groups_adsense_description as "admin.settings.groups.adsense.description" }